import React from 'react';

import {AvailableUserContexts} from 'web-app/react/top-bar/profile-menu/types';

type Choice = AvailableUserContexts[number];

export const useFilteredUserContexts = <C extends Choice>(availableUserContexts: Array<C>) => {
    const [searchQuery, setSearchQuery] = React.useState('');

    const showSearchField = availableUserContexts.length >= 10;

    const filteredContexts = React.useMemo(() => {
        if (!showSearchField || searchQuery === '') {
            return availableUserContexts;
        }

        const cleanedSearchQuery = searchQuery.toLowerCase();

        return availableUserContexts.filter(item => {
            switch (item.target.__typename) {
                case 'InstitutionSet':
                    return item.target.title.toLowerCase().includes(cleanedSearchQuery);
                case 'PersonContextTarget':
                    return item.target.children.some(child =>
                        child.name.fullName.toLowerCase().includes(cleanedSearchQuery),
                    );
                // Person and NoContextTarget are per the backend's documentation deprecated
                // Defaulting to true in any case (also for the default case) to ensure that
                // we don't filter out e.g. new context types in mobile apps.
                case 'Person':
                case 'NoContextTarget':
                default:
                    return true;
            }
        });
    }, [availableUserContexts, searchQuery, showSearchField]);

    return {
        searchQuery,
        setSearchQuery,
        filteredContexts,
        showSearchField,
    };
};
